module.exports = __webpack_public_path__ + "img/lock_fill.5895d6b9.svg";